import { render, staticRenderFns } from "./InventoryStatusesModal.vue?vue&type=template&id=840c2548&scoped=true"
import script from "./InventoryStatusesModal.vue?vue&type=script&lang=js"
export * from "./InventoryStatusesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "840c2548",
  null
  
)

export default component.exports